<template>
  <div id="messageListSettingContainer">
    <div id="backgroundBoard" @click="closeMenu"></div>
    <div id="messageListSettingMenu">
      <div id="menuCloseButton" @click="closeMenu"></div>
      <div class="settingMenu" v-for="(menu, index) in menuItem" :key="index">
        <div class="settingMenuTitle">{{menu.menuTitle}}</div>
        <form>
          <div class="settingMenuItem" v-for="(item, index) in menu.items" :key="index">
            <span class="settingMenuItemValue">{{item.itemName}}</span>
            <div v-for="(value, index) in item.values" :key="index">
              <input type="radio" :name="item.valueName" class="settingMenuItemValue" :value="value.value" :checked="value.selected" @click="item.changeMethod">
              <label>{{value.name}}</label>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import * as Cookies from 'js-cookie'

export default {
  data: function () {
    return {
      menuItem: [
        {
          'menuTitle': '수신설정',
          'items': [
            {
              'itemName': '1:1채팅',
              'valueName': 'allow_date',
              'values': [
                {'name': '모두', 'value': 'Y', 'selected': true},
                {'name': '친구만', 'value': 'F', 'selected': false},
                {'name': '허용안함', 'value': 'N', 'selected': false}
              ],
              'changeMethod': () => {}
            },
            {
              'itemName': '회원초대',
              'valueName': 'allow_invite',
              'values': [
                {'name': '모두', 'value': 'Y', 'selected': true},
                {'name': '친구만', 'value': 'F', 'selected': false},
                {'name': '허용안함', 'value': 'N', 'selected': false}
              ],
              'changeMethod': () => {}
            }
          ]
        }
      ]
    }
  },
  methods: {
    closeMenu: function (event) {
      // console.log(this)
      this.$el.style.opacity = '0'
      this.$el.style.visibility = 'hidden'
      this.updateSettingValue()
    },
    updateSettingValue: function (event) {
      let formData = ''
      for (var index in this.menuItem) {
        let settingItems = this.menuItem[index].items
        for (var key in settingItems) {
          // make FormData format String
          let element = settingItems[key]
          let formDataKey = element.valueName
          let formDataValue = (document.querySelector('input[name="' + element.valueName + '"]:checked').value).replace('all', 'Y').replace('friends', 'F').replace('none', 'N')
          formData += formDataKey + '=' + formDataValue
          if (key < (settingItems.length - 1)) {
            formData += '&'
          }
          // save Settings value
          element.values[0].selected = formDataValue === 'Y'
          element.values[1].selected = formDataValue === 'F'
          element.values[2].selected = formDataValue === 'N'
        }
        // console.log(formData)
        axios.post('/nlivechat/ajax.config_save.php', formData)
        .then(response => {
          if (response.data == 1) { // eslint-disable-line
            printNotifyMessage('수신 설정이 변경 되었습니다.') // eslint-disable-line
            Cookies.set('new_chat_config', JSON.stringify(settingItems))
          }
        }).catch(error => {
          console.error('ERROR IN CHATTING CONFIG!', error)
        })
      }
    }
  },
  mounted () {
    try {
      var configData = JSON.parse(decodeURIComponent(Cookies.get('new_chat_config')))
      if (configData !== undefined) {
        this.menuItem[0].items = configData
      }
    } catch (error) {
      // console.error('chat-message-setting-menu mounted ERROR', error)
    }
  }
}
</script>

<style lang="scss">
#messageListSettingContainer {
  opacity: 0;
  visibility: hidden;
  position: absolute;
  z-index:1001;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  font-size: 12px;
  #menuCloseButton {
    display: block;
    width: 17px;
    height: 17px;
    background: url(/nlivechat/img/sp_chat.png) no-repeat 0 -290px;
    text-indent: -9999px;
    overflow: hidden;
    position: absolute;
    top: 0;
    right: 3px;
    margin: 17px;
  }
  #backgroundBoard {
    background-color: rgba(0,0,0,0.5);
    width: 100%;
    height: 100%;
  }
  #messageListSettingMenu {
    position: fixed;
    top: 50%;
    left: 50%;
    /* bring your own prefixes */
    transform: translate(-50%, -50%);
    width: 80%;
    min-width: 270px;
    .settingMenu {
      display: block;
      background-color: #fff;
      overflow: visible;
      .settingMenuTitle {
        line-height: 51px;
        height: 51px;
        padding-left: 20px;
      }
      .settingMenuItem {
        line-height: 51px;
        height: 51px;
        span, div {
          float: left;
        }
        span {
          width: 60px;
          margin: 0 0 0 3%;
        }
        div {
          margin: 0 3% 0 0;
          input {
            margin-top: 18px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// chat-message-setting-menu.vue?2b9246e7